import IntercomArticle from '../model/intercomArticle'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchIntercomArticles(term: string, limit: number): Promise<RequestResponse<IntercomArticle[]>> {
  return secureRequest('GET', url('/v2/intercom/articles', { term, limit }))
}
